import { useNavigate } from 'react-router-dom';
import { trackCheckoutSessionStarted, trackDemoStarted } from '../utils/analytics';
import { buildStripeUrl } from '../utils/environment';

const CallToAction = () => {
  const navigate = useNavigate();
  const handlePrimaryClick = () => {
    trackCheckoutSessionStarted('cta');
    
    const stripeUrl = buildStripeUrl();
    if (stripeUrl) {
      window.open(stripeUrl, '_blank');
    } else {
      console.error('Failed to build Stripe URL. Check environment configuration.');
    }
  };

  const handleLearnMoreClick = () => {
    trackDemoStarted('cta');
    navigate('/demo');
  };

  return (
    <section className="cta">
      <div className="cta-container">
        <h2>Ready to chart your path?</h2>
        <p>
          50% off pricing ends soon — own Solidly Finance for life. Download today and take the first step to achieve your financial dreams.
        </p>
        <div className="hero-buttons">
          <button 
            className="btn btn-primary"
            onClick={handlePrimaryClick}
          >
            Unlock Lifetime Access (50% OFF Today) →
          </button>
          <button 
            className="btn btn-secondary"
            onClick={handleLearnMoreClick}
          >
            Watch Demo Video
          </button>
        </div>
        <p className="cta-guarantee">
          7-day refund guarantee. One purchase, lifetime use.
        </p>
      </div>
    </section>
  );
};

export default CallToAction;